import classNames from 'classnames';

import Button from 'shared/components/button/Button';
import { getText, zeroPad } from 'shared/utils/Text';

import styles from './index.module.scss';

function formatDuration(milliseconds) {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${zeroPad(seconds)}`;
}

const ClaimControls = ({
  collaborators,
  claimStatus,
  remainingClaimTime,
  claimBet,
  releaseBet,
}) => {
  const canClaim = !claimStatus.claimed;
  const currentOwner = collaborators.find(
    collaborator => collaborator.id === claimStatus.currentOwner,
  );
  const claimedBySelf = currentOwner?.self;
  let claimInfo = '';
  if (claimedBySelf) {
    claimInfo = getText('claim-controls-claimed-by-me');
  } else if (claimStatus.claimed && currentOwner) {
    claimInfo = getText('claim-controls-claimed-by-other', currentOwner.alias);
  }
  return (
    <div className={styles.root}>
      <div className={styles.controls}>
        {canClaim && (
          <Button className={styles.button} onClick={claimBet}>
            {getText('claim-controls-claim-button')}
          </Button>
        )}
        {claimedBySelf && (
          <Button
            className={classNames(styles.button, styles.releaseButton)}
            onClick={releaseBet}
          >
            {getText('claim-controls-release-button')}
          </Button>
        )}
        <div>{claimInfo}</div>
      </div>
      {!canClaim && remainingClaimTime > 0 && (
        <div className={styles.autoReleaseContainer}>
          <div>
            {getText(
              claimedBySelf
                ? 'claim-controls-auto-release-info-self'
                : 'claim-controls-auto-release-info-other',
            )}
          </div>
          <div className={styles.progressContainer}>
            <div className={styles.progressBarOuter}>
              <div
                className={styles.progressBarInner}
                style={{ width: `${(100 * remainingClaimTime) / 300_000}%` }}
              ></div>
            </div>
            <div className={styles.remainingTimeLabel}>
              {formatDuration(remainingClaimTime)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClaimControls;
